export var MINIMUM_VERTICAL_PADDING = 7;
export var DEFAULT_TOP_PADDING = 20;
var DISTANCE_FROM_DIVIDING_LINE = 10;
export default (function (_ref) {
  var colors = _ref.colors,
    sizes = _ref.sizes;
  return {
    container: {
      display: 'inline-block',
      position: 'relative',
      height: '100%',
      verticalAlign: 'top',
      width: '100%'
    },
    icon: {
      color: colors.primary,
      textAlign: 'center',
      marginTop: '15px'
    },
    input: {
      boxSizing: 'border-box',
      color: colors.inputColor,
      border: 'none',
      outline: 'none',
      WebkitAppearance: 'none',
      transition: 'border-color .2s, padding .1s',
      width: '100%',
      height: '100%',
      paddingTop: "".concat(DEFAULT_TOP_PADDING, "px"),
      paddingRight: '35px',
      paddingBottom: "".concat(MINIMUM_VERTICAL_PADDING, "px"),
      paddingLeft: '15px',
      fontSize: '16px',
      fontWeight: 400,
      textOverflow: 'ellipsis'
    },
    input__password: {
      paddingRight: '60px'
    },
    input__hasActionButton: {
      paddingRight: 0
    },
    unit: {
      position: 'absolute',
      left: '100%',
      display: 'inline-block',
      fontWeight: '300',
      color: colors.grayLight,
      height: sizes.inputHeight,
      lineHeight: sizes.inputHeight,
      padding: '0 5px 0 10px',
      userSelect: 'none'
    },
    passwordToggle: {
      position: 'absolute',
      right: 0,
      top: '50%',
      paddingRight: '10px',
      transform: 'translateY(-50%)',
      cursor: 'pointer',
      fill: colors.inputColor,
      zIndex: '10'
    },
    passwordToggle__withIndicator: {
      right: '0',
      width: '72px'
    },
    iconDivider: {
      width: '1px',
      borderLeft: "1px solid ".concat(colors.inputBorder),
      height: '25px',
      position: 'absolute',
      right: '35px',
      top: '50%',
      transform: 'translateY(-50%)'
    },
    passwordToggleIcon: {
      display: 'block',
      width: '25px',
      height: '25px'
    },
    passwordToggleIcon__visible: {
      fill: colors.primary
    },
    // action button styles
    // user agent button de-styling:
    button__destyled: {
      backgroundColor: 'transparent',
      border: 'none',
      padding: 0,
      font: 'inherit',
      color: 'inherit'
    },
    actionButtonWrapper: {
      position: 'absolute',
      right: 0,
      top: 0,
      height: '100%',
      display: 'flex',
      cursor: 'pointer'
    },
    deleteButton: {
      paddingRight: "".concat(DISTANCE_FROM_DIVIDING_LINE, "px"),
      height: '100%',
      fontSize: '22px',
      color: colors.gray,
      cursor: 'inherit'
    },
    actionButton: {
      color: colors.secondaryDarker,
      textDecoration: 'underline',
      height: '100%',
      fontSize: '13px',
      fontWeight: 500,
      boxShadow: "-7px 0 2px -7px ".concat(colors.gray),
      paddingLeft: "".concat(DISTANCE_FROM_DIVIDING_LINE, "px"),
      paddingRight: '10px',
      overflow: 'hidden',
      'button&': {
        cursor: 'inherit'
      }
    },
    actionButton__success: {
      color: colors.primary,
      textDecoration: 'none',
      fontSize: '12px',
      display: 'inline-block',
      cursor: 'default',
      lineHeight: '49px',
      '& svg': {
        fill: colors.primary,
        marginRight: '5px',
        marginBottom: '-2px'
      }
    },
    input__disabled: {
      cursor: 'not-allowed'
    },
    // stub class presence needed for in-project
    // ability to overwrite through `classes` prop
    input__error: {}
  };
});